<template>
<div class="position-relative gold-bg" :style="columnMargin">
  <img v-if="item.bgImg" class="ajax-cover-bg" :src='item.bgImg' />
  <div class="gold-area" @scroll="onScroll">
    <div :class="[index == 0 ? 'max-area': 'min-area']" v-for="(goldList,index) in item.goldList" :key="index">
      <div @click="doLocationHref(gold)" :class="[index == 0 ? 'max-one': 'min-one']" v-for="(gold,goldIndex) in goldList" :key="goldIndex">
        <img :class="[index == 0 ? 'max-img': 'min-img']" :src="curGifObj.colIndex == index && curGifObj.rowIndex == goldIndex ? gold.gifUrl : gold.imgUrl" alt="">
        <div>{{gold.adName}}</div>
      </div>
    </div>
  </div>
  <div class="scrollBox">
    <div class="scroll-thumb" :style="{'left':scrollLeftPrecent}"></div>
  </div>
</div>
</template>

<script>
export default { 
  name: 'GoldArea',
  data() {
    return {
      gifTimer1: '',
      gifTimer2: '',
      curGifObj: {
        colIndex: -1,
        rowIndex: -1,
        curIndex: 0
      },
      scrollLeft:0,
      scrollLeftPrecent:0
    }
  },
  props: {
    item: Object,
  },
  components: {
  },
  created() {
  },
  mounted() {
    this.gifTimeout()
  },
  watch: {
    resetGoldAreaTime: function (val) {
      if(val){
        clearTimeout(this.gifTimer1)
        clearTimeout(this.gifTimer2)
        this.curGifObj = {
          colIndex: -1,
          rowIndex: -1,
          curIndex: 0
        }
        this.gifTimeout()
      }
    },
  },
  computed: {
    resetGoldAreaTime: function(){
      return this.$store.state.home.resetGoldAreaTime
    },
    columnMargin(){
      var obj = {}
      if(this.item.marginObj){
        obj={
          'margin-top': this.item.marginObj.top,
          'margin-bottom': this.item.marginObj.bottom
        }
      }
			return obj
    }
  },
  methods: {
    onScroll(event){
      this.scrollLeft = event.target.scrollLeft;
      var goldWidth = document.getElementsByClassName("gold-area")[0].scrollWidth - document.getElementsByClassName("gold-area")[0].clientWidth;
      var leftNum = (document.getElementsByClassName("scrollBox")[0].clientWidth - document.getElementsByClassName("scroll-thumb")[0].clientWidth)*(this.scrollLeft/goldWidth) 
      this.scrollLeftPrecent = leftNum + "px"
    },
    gifTimeout(){
      var t = this
      if(t.item.gifRecordList.length < 1){
        return
      }
      clearTimeout(t.gifTimer1)
      clearTimeout(t.gifTimer2)
      t.gifTimer1 = setTimeout(() => {
        t.curGifObj.curIndex >= t.item.gifRecordList.length && (t.curGifObj.curIndex = 0);
        t.curGifObj.colIndex = t.item.gifRecordList[t.curGifObj.curIndex].colIndex;
        t.curGifObj.rowIndex = t.item.gifRecordList[t.curGifObj.curIndex].rowIndex;
        t.curGifObj.curIndex = t.curGifObj.curIndex + 1
        t.gifTimer2 = setTimeout(() => {
          t.curGifObj.colIndex = -1
          t.curGifObj.rowIndex = -1
          t.gifTimeout()
        }, t.item.gifTime);
      }, 3000);
    },
    doLocationHref(obj){
      var self = this
      this.$store.commit('doTrack',{
        href: obj.adHrefUrl,
        columnDefineId: self.item.columnDefineId,
        ccId: obj.ccId,
        adId: obj.adId,
        adName: obj.adName,
        idType: 'adId'
      });
      window.location.href = obj.adHrefUrl
    },
  }
}
</script>

<style scoped>
.gold-bg{
  margin-top: 10px;
  width: 375px;
  height: 150px;
  overflow: hidden
}
.gold-area{
  font-size: 12px;
  color: #333;
  width: 375px;
  height: 150px;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
}
.gold-area::-webkit-scrollbar{
  display:none;
}
.scrollBox{
  position: absolute;
  bottom: 2px;
  left: 50%;
  transform: translate(-50%);
  width: 40px;
  background-color: #e8e8e8;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  overflow: hidden;
}
.scroll-thumb{
  width: 24px;
  height: 2px;
  background-color: rgb(213, 36, 39);
  position: relative;
}
.max-area, .min-area{
  min-width: 375px;
  display: flex;
}
.max-one{
  flex-basis: 75px;
  flex-shrink: 0;
  white-space: nowrap;
  height: 72px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.max-img{
  width: 42px;
  height: 42px;
  display: block;
  margin-top: 6px;
  margin-bottom: 2px;
}
.min-one{
  margin-top: 8px;
  flex-basis: 75px;
  flex-shrink: 0;
  white-space: nowrap;
  height: 55px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.min-img{
  width: 32px;
  height: 32px;
  display: block;
  margin-bottom: 2px;
}
</style>